<div
  class="confirmation-elton-modal__modal-backdrop"
  *ngIf="open"
></div>

<div
  class="confirmation-elton-modal__modal"
  *ngIf="open"
  role="dialog"
  aria-modal="true"
  aria-labelledby="elton-modal-title"
>
  <mat-card
    class="confirmation-elton-modal__modal-dialog"
    role="document"
  >
    <mat-card-header class="confirmation-elton-modal__modal-header">
      <mat-card-title>
        <span
          id="elton-modal-title"
          class="confirmation-elton-modal__modal-title"
        >
          Hertz + Elton
        </span>
      </mat-card-title>

      <button
        type="button"
        class="confirmation-elton-modal__modal-close"
        (click)="closed.emit()"
      >
        <span class="confirmation-elton-modal__modal-close-x">&times;</span>
        {{ 'close' | translate }}
      </button>
    </mat-card-header>
    <img
      class="confirmation-elton-modal__modal-img"
      src="assets/img/elton_img.png"
      alt="Elton image"
      width="960"
      height="418"
    />
    <mat-card-content class="confirmation-elton-modal__modal-body">

      <h2 class="confirmation-elton-modal__modal-subtitle">
        <span>{{ 'charge-rental-elton-title' | translate }}</span>
        <img
          class="confirmation-elton-modal__modal-subtitle-icon"
          src="assets/icons/elton_icon.png"
          alt="Elton icon"
          width="18"
          height="18"
        />
      </h2>

      <p class="confirmation-elton-modal__modal-text">
        {{ 'confirmation-elton-text-modal' | translate }}
      </p>

      <p class="confirmation-elton-modal__modal-text">
        {{ 'confirmation-elton-text-modal-second' | translate }}
      </p>

      <div class="confirmation-elton-modal__modal-store-buttons">
        <button
          type="button"
          class="confirmation-elton-modal__store-button"
          (click)="openAppStore()"
        >
          <img
            src="assets/icons/download_app_store.png"
            alt="Download on the App Store"
            class="confirmation-elton-modal__store-image"
            width="250"
            height="84"
          />
        </button>

        <button
          type="button"
          class="confirmation-elton-modal__store-button"
          (click)="openGooglePlay()"
        >
          <img
            src="assets/icons/download_google_play_store.png"
            alt="Get it on Google Play"
            class="confirmation-elton-modal__store-image"
            width="250"
            height="77"
          />
        </button>
      </div>

      <p class="confirmation-elton-modal__modal-text">
        {{ 'confirmation-elton-text-modal-third' | translate }}
      </p>

      <p class="confirmation-elton-modal__modal-text">
        {{ 'confirmation-elton-text-modal-fourth' | translate }}
      </p>

    </mat-card-content>

    <mat-card-actions class="confirmation-elton-modal__actions">
      <button
        type="button"
        class="confirmation-elton-modal__modal-ok"
        (click)="closed.emit()"
      >
        {{ 'confirmation-elton-button-text' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
